<template>
    <div>
        <main class="fix">
            <!-- Breadcrumb Area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
                    :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="breadcrumb__content">
                                <h2 class="title">Survei Kepuasan Masyarakat (SKM)</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <a href="javascript:void(0);" @click="$router.push('/')">Beranda</a>
                                        </li>
                                        <li class="breadcrumb-item">SKM</li>
                                        <li class="breadcrumb-item active" aria-current="page">Layanan LPSE</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>

            <!-- Main Content Area -->
            <section class="skm__area py-5">
                <div class="container">

                    <!-- Header Banner Card -->
                    <div class="skm-hero-card mb-4 p-4 rounded-4 shadow-sm bg-white border border-light-subtle">
                        <div class="row align-items-center">
                            <div class="col-lg-8 mb-3 mb-lg-0">
                                <h3 class="fw-bold text-dark mb-1">
                                    {{ aplikasi.nama }} &mdash; {{ aplikasi.keterangan }}
                                </h3>
                                <p class="text-secondary mb-0">
                                    Hasil evaluasi dan penilaian Survei Kepuasan Masyarakat (SKM) terhadap mutu pelayanan Layanan Pengadaan Secara Elektronik (LPSE) pada Bagian Pengadaan Barang dan Jasa Kabupaten Konawe Selatan.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Highlight Statistics Cards -->
                    <div class="row g-3 mb-4">
                        <!-- Skor IKM -->
                        <div class="col-xl-3 col-md-6">
                            <div class="stat-card h-100 p-4 rounded-4 bg-white shadow-sm border border-light-subtle d-flex flex-column justify-content-between position-relative overflow-hidden">
                                <div class="stat-icon-bg bg-primary-subtle text-primary">
                                    <i class="fas fa-star"></i>
                                </div>
                                <div>
                                    <span class="text-uppercase text-muted fw-bold small">Indeks Kepuasan (IKM)</span>
                                    <div class="d-flex align-items-baseline gap-2 mt-2">
                                        <h2 class="display-6 fw-bold text-dark mb-0">{{ formatNumber(summary.skor) }}</h2>
                                        <span class="text-muted fw-semibold">/ 5.0</span>
                                    </div>
                                    <div class="rating-stars mt-2">
                                        <span v-for="n in 5" :key="n" class="me-1">
                                            <i :class="getStarClass(n, summary.skor)"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Predikat Mutu -->
                        <div class="col-xl-3 col-md-6">
                            <div class="stat-card h-100 p-4 rounded-4 bg-white shadow-sm border border-light-subtle d-flex flex-column justify-content-between position-relative overflow-hidden">
                                <div class="stat-icon-bg bg-success-subtle text-success">
                                    <i class="fas fa-award"></i>
                                </div>
                                <div>
                                    <span class="text-uppercase text-muted fw-bold small">Mutu Pelayanan</span>
                                    <div class="mt-2">
                                        <span :class="['badge rounded-pill px-3 py-2 fs-6 fw-bold', getMutuBadgeClass(summary.mutu)]">
                                            {{ summary.mutu || 'Sangat Baik (A)' }}
                                        </span>
                                    </div>
                                    <p class="text-muted small mt-2 mb-0">
                                        Kategori predikat berdasarkan standar evaluasi pelayanan publik KemenPAN-RB.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Total Responden -->
                        <div class="col-xl-3 col-md-6">
                            <div class="stat-card h-100 p-4 rounded-4 bg-white shadow-sm border border-light-subtle d-flex flex-column justify-content-between position-relative overflow-hidden">
                                <div class="stat-icon-bg bg-info-subtle text-info">
                                    <i class="fas fa-users"></i>
                                </div>
                                <div>
                                    <span class="text-uppercase text-muted fw-bold small">Total Responden</span>
                                    <div class="d-flex align-items-baseline gap-2 mt-2">
                                        <h2 class="display-6 fw-bold text-dark mb-0">{{ summary.totalResponden || 0 }}</h2>
                                        <span class="text-muted fw-semibold">Orang</span>
                                    </div>
                                    <p class="text-muted small mt-2 mb-0">
                                        Partisipasi masyarakat dan penyedia barang/jasa dalam survei layanan LPSE.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Persentase Kepuasan -->
                        <div class="col-xl-3 col-md-6">
                            <div class="stat-card h-100 p-4 rounded-4 bg-white shadow-sm border border-light-subtle d-flex flex-column justify-content-between position-relative overflow-hidden">
                                <div class="stat-icon-bg bg-warning-subtle text-warning">
                                    <i class="fas fa-smile"></i>
                                </div>
                                <div>
                                    <span class="text-uppercase text-muted fw-bold small">Tingkat Kepuasan</span>
                                    <div class="d-flex align-items-baseline gap-2 mt-2">
                                        <h2 class="display-6 fw-bold text-success mb-0">{{ summary.persentasePuas || 0 }}%</h2>
                                    </div>
                                    <div class="progress mt-2" style="height: 8px;">
                                        <div class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                                            role="progressbar"
                                            :style="{ width: (summary.persentasePuas || 0) + '%' }"
                                            aria-valuenow="summary.persentasePuas" aria-valuemin="0" aria-valuemax="100">
                                        </div>
                                    </div>
                                    <p class="text-muted small mt-2 mb-0">
                                        Menyatakan <strong>Puas</strong> dan <strong>Sangat Puas</strong> terhadap layanan.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Distribusi Rating & Filter Card -->
                    <div class="card rounded-4 shadow-sm border border-light-subtle mb-4">
                        <div class="card-body p-4">
                            <div class="row align-items-center">
                                <div class="col-lg-5 border-end-lg pe-lg-4 mb-4 mb-lg-0">
                                    <h5 class="fw-bold text-dark mb-1">Distribusi Penilaian Bintang</h5>
                                    <p class="text-muted small mb-3">Rincian suara kepuasan responden per tingkatan bintang.</p>

                                    <div class="distribution-list">
                                        <div v-if="loading && (!summary.distribusiRating || summary.distribusiRating.length === 0)" class="text-center py-4">
                                            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                                            <span class="text-muted small">Memuat data dari server...</span>
                                        </div>
                                        <div v-for="item in summary.distribusiRating" :key="item.bintang"
                                            class="rating-row d-flex align-items-center gap-2 mb-2 p-1 rounded-3"
                                            :class="{ 'active-rating-filter': selectedRating === item.bintang }"
                                            @click="toggleRatingFilter(item.bintang)"
                                            style="cursor: pointer;"
                                            :title="'Klik untuk memfilter ulasan ' + item.bintang + ' bintang'">
                                            <span class="text-muted small fw-semibold" style="width: 65px;">
                                                {{ item.bintang }} <i class="fas fa-star text-warning" style="font-size: 11px;"></i>
                                            </span>
                                            <div class="progress flex-grow-1" style="height: 10px; background-color: #f1f5f9;">
                                                <div class="progress-bar rounded-pill" role="progressbar"
                                                    :style="{ width: item.persentase + '%', backgroundColor: item.fill || '#10b981' }"
                                                    :aria-valuenow="item.persentase" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <span class="text-dark small fw-bold" style="width: 50px; text-align: right;">
                                                {{ item.persentase }}%
                                            </span>
                                            <span class="badge bg-light text-secondary rounded-pill border" style="width: 60px;">
                                                {{ item.jumlah }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-end mt-2">
                                        <button v-if="selectedRating !== null" class="btn btn-sm btn-link text-decoration-none p-0 text-primary"
                                            @click="selectedRating = null">
                                            <i class="fas fa-times me-1"></i> Reset Filter Rating
                                        </button>
                                    </div>
                                </div>

                                <div class="col-lg-7 ps-lg-4">
                                    <div class="d-flex flex-column h-100 justify-content-between">
                                        <div>
                                            <h5 class="fw-bold text-dark mb-2">Maklumat Pelayanan LPSE</h5>
                                            <p class="text-muted small mb-3">
                                                Pelayanan Layanan Pengadaan Secara Elektronik (LPSE) Kabupaten Konawe Selatan berkomitmen memberikan pelayanan yang cepat, transparan, akuntabel, dan bebas dari gratifikasi sesuai dengan prinsip-prinsip tata kelola pemerintahan yang baik (Good Governance).
                                            </p>
                                        </div>

                                        <div class="row g-2 pt-2">
                                            <div class="col-sm-4">
                                                <div class="p-3 rounded-3 bg-light border text-center">
                                                    <i class="fas fa-tachometer-alt text-primary mb-1 fs-5"></i>
                                                    <h6 class="fw-bold text-dark mb-0 small">Cepat & Responsif</h6>
                                                    <span class="text-muted" style="font-size: 11px;">Pelayanan Tepat Waktu</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="p-3 rounded-3 bg-light border text-center">
                                                    <i class="fas fa-search-dollar text-success mb-1 fs-5"></i>
                                                    <h6 class="fw-bold text-dark mb-0 small">100% Transparan</h6>
                                                    <span class="text-muted" style="font-size: 11px;">Akses LPSE Terbuka</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="p-3 rounded-3 bg-light border text-center">
                                                    <i class="fas fa-hand-holding-heart text-danger mb-1 fs-5"></i>
                                                    <h6 class="fw-bold text-dark mb-0 small">Bebas Biaya</h6>
                                                    <span class="text-muted" style="font-size: 11px;">Tanpa Pungutan Liar</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </main>
    </div>
</template>

<script>
export default {
    name: 'SkmLpseView',
    data() {
        return {
            loading: true,
            isLiveApi: false,
            apiErrorMessage: '',
            searchQuery: '',
            selectedRating: null,
            currentPage: 1,
            pageSize: 10,

            aplikasi: {
                id: '',
                nama: '',
                keterangan: ''
            },
            summary: {
                skor: 0,
                totalResponden: 0,
                mutu: '-',
                persentasePuas: 0,
                distribusiRating: []
            },
            pagination: {
                page: 1,
                limit: 10,
                totalPages: 1,
                totalData: 0
            },
            ulasanList: []
        }
    },
    computed: {
        apiUrl() {
            return (this.$store && this.$store.state && this.$store.state.url && this.$store.state.url.URL_SKM_RUP)
                ? this.$store.state.url.URL_SKM_RUP
                : 'https://konsel-setara.konaweselatankab.go.id/api/v1/skm/rup';
        },
        filteredReviews() {
            let list = this.ulasanList || [];

            // Filter by star rating
            if (this.selectedRating !== null) {
                list = list.filter(item => Number(item.rating) === this.selectedRating);
            }

            // Filter by search query
            if (this.searchQuery && this.searchQuery.trim() !== '') {
                const q = this.searchQuery.toLowerCase();
                list = list.filter(item => {
                    const nama = (item.nama || '').toLowerCase();
                    const komentar = (item.komentar || '').toLowerCase();
                    return nama.includes(q) || komentar.includes(q);
                });
            }

            return list;
        },
        totalPages() {
            if (this.isLiveApi && this.pagination && this.pagination.totalPages) {
                return this.pagination.totalPages;
            }
            return Math.max(1, Math.ceil(this.filteredReviews.length / this.pageSize));
        },
        paginatedReviews() {
            if (this.isLiveApi) {
                return this.filteredReviews;
            }
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredReviews.slice(start, start + this.pageSize);
        },
        visiblePages() {
            const total = this.totalPages;
            const current = this.currentPage;
            const pages = [];
            const maxVisible = 5;

            let start = Math.max(1, current - 2);
            let end = Math.min(total, start + maxVisible - 1);
            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        async fetchData(page = 1) {
            this.loading = true;
            this.apiErrorMessage = '';
            this.currentPage = page;

            try {
                // Try GET with query parameters
                const targetUrl = `${this.apiUrl}?page=${page}&limit=${this.pageSize}`;
                const response = await fetch(targetUrl, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                    }
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result && result.success) {
                        this.isLiveApi = true;
                        if (result.aplikasi) this.aplikasi = result.aplikasi;
                        if (result.summary) this.summary = result.summary;
                        if (result.pagination) this.pagination = result.pagination;
                        if (Array.isArray(result.data)) {
                            this.ulasanList = result.data;
                        }
                        this.loading = false;
                        return;
                    }
                }

                // If GET was not ok, try POST
                const postResponse = await fetch(this.apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ page: page, limit: this.pageSize })
                });

                if (postResponse.ok) {
                    const postResult = await postResponse.json();
                    if (postResult && postResult.success) {
                        this.isLiveApi = true;
                        if (postResult.aplikasi) this.aplikasi = postResult.aplikasi;
                        if (postResult.summary) this.summary = postResult.summary;
                        if (postResult.pagination) this.pagination = postResult.pagination;
                        if (Array.isArray(postResult.data)) {
                            this.ulasanList = postResult.data;
                        }
                        this.loading = false;
                        return;
                    }
                }

                // If both fail, keep current state and notify
                this.isLiveApi = false;
                this.apiErrorMessage = 'Koneksi ke endpoint server sedang disinkronisasi.';
            } catch (err) {
                console.warn('SKM API not available yet, using cached/preview data:', err.message);
                this.isLiveApi = false;
                this.apiErrorMessage = err.message;
            } finally {
                this.loading = false;
            }
        },

        toggleRatingFilter(star) {
            if (this.selectedRating === star) {
                this.selectedRating = null;
            } else {
                this.selectedRating = star;
            }
        },

        resetFilters() {
            this.selectedRating = null;
            this.searchQuery = '';
        },

        changePage(p) {
            if (p >= 1 && p <= this.totalPages) {
                this.currentPage = p;
                if (this.isLiveApi) {
                    this.fetchData(p);
                }
                window.scrollTo({ top: 400, behavior: 'smooth' });
            }
        },

        formatNumber(num) {
            if (num === null || num === undefined) return '0.0';
            return Number(num).toFixed(1);
        },

        getStarClass(pos, rating) {
            const r = Number(rating) || 0;
            if (r >= pos) {
                return 'fas fa-star text-warning';
            } else if (r >= pos - 0.5) {
                return 'fas fa-star-half-alt text-warning';
            } else {
                return 'far fa-star text-muted';
            }
        },

        getMutuBadgeClass(mutu) {
            if (!mutu) return 'bg-success text-white';
            const m = mutu.toUpperCase();
            if (m.includes('A') || m.includes('SANGAT BAIK')) return 'bg-success text-white shadow-sm';
            if (m.includes('B') || m.includes('BAIK')) return 'bg-primary text-white shadow-sm';
            if (m.includes('C') || m.includes('KURANG')) return 'bg-warning text-dark shadow-sm';
            return 'bg-danger text-white shadow-sm';
        },

        getRatingBadgeClass(rating) {
            const r = Number(rating);
            if (r === 5) return 'bg-success-subtle text-success';
            if (r === 4) return 'bg-primary-subtle text-primary';
            if (r === 3) return 'bg-warning-subtle text-warning-emphasis';
            if (r === 2) return 'bg-orange-subtle text-danger';
            return 'bg-danger-subtle text-danger';
        },

        getRatingLabel(rating) {
            const r = Number(rating);
            if (r === 5) return 'Sangat Puas';
            if (r === 4) return 'Puas';
            if (r === 3) return 'Cukup';
            if (r === 2) return 'Kurang';
            return 'Kecewa';
        },

        getInitials(name) {
            if (!name) return 'M';
            const clean = name.trim().replace(/^(PT|CV|UD)\.?\s+/i, '');
            const parts = clean.split(/\s+/);
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return (clean[0] || 'M').toUpperCase();
        },

        getAvatarColor(name) {
            const colors = ['#2563eb', '#10b981', '#7c3aed', '#059669', '#ea580c', '#0284c7', '#d97706'];
            let hash = 0;
            const str = name || 'Masyarakat';
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return colors[Math.abs(hash) % colors.length];
        },

        formatDate(dateStr) {
            if (!dateStr) return 'Baru saja';
            try {
                const date = new Date(dateStr);
                if (isNaN(date.getTime())) return dateStr;
                return new Intl.DateTimeFormat('id-ID', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                }).format(date);
            } catch (e) {
                return dateStr;
            }
        }
    },
    mounted() {
        this.fetchData(1);
    }
}
</script>

<style scoped>
.skm-hero-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    transition: all 0.3s ease;
}

.stat-card {
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07) !important;
}

.stat-icon-bg {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-bottom: 12px;
}

.rating-row {
    transition: background-color 0.2s ease;
}

.rating-row:hover {
    background-color: #f8fafc;
}

.active-rating-filter {
    background-color: #e0f2fe !important;
    border: 1px solid #7dd3fc;
}

.avatar-circle {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

.review-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.review-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06) !important;
}

.review-text {
    font-style: italic;
    color: #334155;
}

.badge.bg-emerald-subtle {
    background-color: #d1fae5;
    color: #065f46;
}

.badge.bg-primary-subtle {
    background-color: #e0e7ff;
    color: #3730a3;
}

.badge.bg-success-subtle {
    background-color: #dcfce7;
    color: #166534;
}

.badge.bg-info-subtle {
    background-color: #e0f2fe;
    color: #075985;
}

.badge.bg-warning-subtle {
    background-color: #fef9c3;
    color: #854d0e;
}

.badge.bg-danger-subtle {
    background-color: #fee2e2;
    color: #991b1b;
}

.badge.bg-orange-subtle {
    background-color: #ffedd5;
    color: #9a3412;
}

@media (min-width: 992px) {
    .border-end-lg {
        border-right: 1px solid #e2e8f0 !important;
    }
}
</style>
